import { Controller } from "stimulus"

export default class AdvancedController extends Controller { 

  _controllersCache = []

  connect() {
    this.element[this.identifier] = this
  }

  getController(identifier) {
    if (identifier in this._controllersCache) return this._controllersCache[identifier];
    const otherController = document.querySelector(`[data-controller="${identifier}"]`)[`${identifier}`]
    this._controllersCache[identifier] = otherController
    return otherController
  }

  getAllControllers(identifier) {
    const allControllerNodes = document.querySelectorAll(`[data-controller="${identifier}"]`)

    const allControllers = [];
    for (const someControllerNode of allControllerNodes) {
      const someController = someControllerNode[`${identifier}`];
      allControllers.push(someController)
    }
    
    return allControllers
  }

  getSubControllers(identifier) {
    const allControllerNodes = this.element.querySelectorAll(`[data-controller="${identifier}"]`)

    const otherControllers = [];
    for (const otherControllerNode of allControllerNodes) {
      const otherController = otherControllerNode[`${identifier}`];
      if (otherController !== this) {
        otherControllers.push(otherController)
      }
    }
    
    return otherControllers
  }

  getSiblingControllers(identifier) {
    const allControllerNodes = this.element.parentElement.querySelectorAll(`[data-controller="${identifier}"]`)

    const otherControllers = [];
    for (const otherControllerNode of allControllerNodes) {
      const otherController = otherControllerNode[`${identifier}`]
      if (otherController !== this && otherControllerNode.parentElement === this.element.parentElement) {
        otherControllers.push(otherController)
      }
    }
    
    return otherControllers
  }

}